module.exports = __webpack_public_path__ + "media/images/flags/16/Northern-Mariana-Islands-0f2c4780b42a71883277f2f9968956b7.png";